import React from "react"
import { CircularProgress, Toggle } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import UserTimecardStore from "../../stores/UserTimecardStore"
import UserStore from "../../stores/UserStore"
import strings from "../../localization/strings"
import EmployeeTimecardActionBar from "./EmployeeTimecardActionBar"
import AddPunchDialog from "../punch/AddPunchDialog"
import TimecardWeekTable from "./TimecardWeekTable"
import AccountStore from "../../stores/AccountStore"
import autobind from "class-autobind"
import TimecardDailyDrawer from "./daily_drawer/TimecardDailyDrawer"
import { grey400 } from "material-ui/styles/colors"
import ImageLoader from "../misc/ImageLoader"
import * as userActions from "../../actions/UserActions"
import * as punchActions from "../../actions/PunchActions"
import * as timecardHelper from "../../helpers/timecardHelper"
import * as api from "../../api"
import {
	ITimecardEmployee, IDate, EPunchSetApprovalType, IUserDocument, ELoggedInUserType, IObjectTimecardDocument, ITimecardDay,
	IPayrollStatusDocument, IPunchBundle, ECheckResultForRemovedPunchData, ITimecardFullData, IUIUser, ITimecardSequenceResult,
	IPunchResult, ISuspensePunchData, IPunchSetDocument, IJobStatusData, ICommentData, IRuleProperty,
	IUserEffectiveDateDocument,
	IRecord,
	IPunchDocument
} from "../../models"
import ApproveIcon from "../approve/ApproveIcon"
import moment from "moment"
import AppStateStore from "../../stores/AppStateStore"
import * as punchHelper from "../../helpers/punchHelper"
import * as userTimecardActions from "../../actions/UserTimecardActions"
import UserLock from "../../../assets/icons/user-lock"
import EmployeeTimecardPunchDrawer from "../punch/employee_punch_drawer/EmployeeTimecardPunchDrawer"
import PendingTimecardUI from "../timecard_sequence/PendingTimecardUI"
import * as approveActions from "../../actions/ApproveActions"
import PunchResultDialog from "../punch/punch_result/PunchResultDialog"
import TimecardPriorPeriodAdjustments from "./TimecardPriorPeriodAdjustments"
import * as permissionHelper from "../../helpers/permissionHelper"
import TimecardSuspenseInfoIcon from "./TimecardSuspenseInfoIcon"
import TimecardPopup from "./timecard_popup/TimecardPopup"
import * as userHelper from "../../helpers/userHelper"
import HierarchyJobTimezoneStr from "../common/HierarchyJobTimezoneStr"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import AcceptSuspensePunchResultDialog from "../record/AcceptSuspensePunchResultDialog"

interface IProps {
	userId: string
	user: IUserDocument
	timecardApprovals: boolean
	readonly: boolean
	loggedInUserType: ELoggedInUserType

	byPopup?: boolean
	handleRecalcPage?(): void
	// we should show only Job Data in timecard when open popup from Job->Timecard page
	filterByJobId?: string
	// if Job->Timecard, it's not full timecard object. so let's hide Info icon to show Notes, Audits and WorkHistory.
	hideInfoIcon?: boolean

	reloadTimecard?: boolean //web punch need reload timecard
	virtualTimecard?: boolean
	acceptSuspensePunches?: boolean

	//when url has referenceDate as search param, we should use it.
	referenceDate?: string
}
interface IState {
	referenceDate: IDate
	pending: boolean
	pendingReviewed: boolean
	dailyNoteDates: IDate[]
	timecard: IObjectTimecardDocument
	openAddPunchDialog: boolean
	punchTimecardDay: ITimecardDay
	punchTimecard: IObjectTimecardDocument
	loadingTimecards: boolean
	showComponentTimecards: boolean
	showProductiveNonProductiveTime: boolean
	isPunchIn: boolean
	pairedPunchId: string
	dailyDrawerDate: number
	lockData: IPayrollStatusDocument[]
	defaultAddPunchHierarchyId: string
	defaultAddPunchPositionId: string
	defaultAddPayClassId: string
	defaultAddPunchPayTypeId: string
	defaultShiftId: string
	defaultBreakId: string
	defaultMobileBreakId: string
	defaultAddJobId: string
	defaultAddPhaseId: string
	defaultEquipmentId: string
	openPunchDrawer: boolean
	punchActionsResult: IPunchResult[]
	allowPriorPeriodModifications: boolean
	priorPeriodTimecards: IObjectTimecardDocument[]
	suspensePunchData: ISuspensePunchData
	jobStatusData: IJobStatusData[]
	commentData: ICommentData[]
	openVirtualTimecardPopup: boolean
	showTimecardDetails: boolean
	userEffectiveDates: IUserEffectiveDateDocument[]
	acceptSuspensePunchResultDialogContent: {
		selectedRecords: IRecord[]
		acceptResult: any
	}
}

export default class EmployeeTimecard extends React.Component<IProps, IState> {
	private employeePayrollHierarchyItemId
	constructor(props: IProps) {
		super(props)
		this.state = {
			referenceDate: props.referenceDate ? props.referenceDate : UserTimecardStore.getReferenceDate(),
			pending: false,
			pendingReviewed: false,
			dailyNoteDates: [],
			timecard: null,
			openAddPunchDialog: false,
			punchTimecardDay: null,
			punchTimecard: null,
			loadingTimecards: true,
			showComponentTimecards: false,
			showProductiveNonProductiveTime: false,
			isPunchIn: true,
			pairedPunchId: null,
			dailyDrawerDate: null,
			lockData: null,
			defaultAddPunchHierarchyId: null,
			defaultAddPunchPositionId: null,
			defaultAddPayClassId: null,
			defaultAddPunchPayTypeId: null,
			defaultShiftId: null,
			defaultBreakId: null,
			defaultMobileBreakId: null,
			defaultAddJobId: null,
			defaultAddPhaseId: null,
			defaultEquipmentId: null,
			openPunchDrawer: false,
			punchActionsResult: [],
			allowPriorPeriodModifications: false,
			priorPeriodTimecards: [],
			suspensePunchData: null,
			jobStatusData: null,
			commentData: null,
			openVirtualTimecardPopup: false,
			showTimecardDetails: localStorage.getItem("showTimecardDetails") === "true",
			userEffectiveDates: [],
			acceptSuspensePunchResultDialogContent: null
		}

		autobind(this)
		this.employeePayrollHierarchyItemId = UserStore.getCurrentUserDetail().PayrollHierarchyItemId
	}

	componentDidMount() {
		this.getUserEffectiveDates()
		UserStore.on("change", this.changeEvent)
		UserStore.on("change_payroll_setting", this.getUserEffectiveDates)
	}

	componentWillReceiveProps(nextProps: IProps) {
		(nextProps.reloadTimecard || (nextProps.user.DefaultHierarchyItemId !== this.props.user.DefaultHierarchyItemId)) &&
			this.loadTimecards()

		!this.props.acceptSuspensePunches && nextProps.acceptSuspensePunches &&
			this.handleAcceptSuspensePunches()

		if (this.props.referenceDate !== nextProps.referenceDate) {
			this.setState({ referenceDate: nextProps.referenceDate }, () =>
				this.loadTimecards()
			)
		}
	}

	componentWillUnmount() {
		UserStore.removeListener("change", this.changeEvent)
		UserStore.removeListener("change_payroll_setting", this.getUserEffectiveDates)
	}

	changeEvent() {
		if (!UserStore.getCurrentUserDetail() || this.employeePayrollHierarchyItemId === UserStore.getCurrentUserDetail().PayrollHierarchyItemId) return
		this.loadTimecards()
		this.employeePayrollHierarchyItemId = UserStore.getCurrentUserDetail().PayrollHierarchyItemId
	}

	changeEventUserTimecard() {
		this.loadTimecards()
	}

	async getUserEffectiveDates() {
		const res = await api.getUserEffectiveDates(this.props.userId)
		this.setState({ userEffectiveDates: res.data }, () =>
			this.loadTimecards()
		)
	}

	async loadTimecards(msg?: string) {
		let timecardFullDataRes
		try {
			AppStateStore.setProgressSnackbarContent("loading")
			timecardFullDataRes = await api.getUserTimecardFullData(this.props.userId, moment(this.state.referenceDate).utc(true).format(), this.props.virtualTimecard ? true : false, this.props.filterByJobId || "")
			AppStateStore.setProgressSnackbarContent(null)
		}
		catch (error) {
			error.response.data.message.includes("invalid payroll hierarchy") &&
				AppStateStore.setBannerAlertContent(strings.The_employee_payroll_level_is_not_valid_please_update_payroll_level)
		}

		const result: ITimecardFullData = timecardFullDataRes.data
		const now = moment()
		if (result.Timecard && now.isBetween(result.Timecard.StartDate, result.Timecard.EndDate)) {
			const TimecardWeek = result.Timecard.MasterTimecard.TimecardWeeks[0];
			const WeeklyHours = TimecardWeek.TotalProductiveInMinutes;

			for (let i = 0; i < TimecardWeek.Days.length; i++) {
				if (now.isBetween(TimecardWeek.Days[i].StartDayTime, TimecardWeek.Days[i].EndDayTime)) {
					const DailyHours = TimecardWeek.Days[i].TotalProductiveInMinutes;
					userActions.setUserStatsHours({ DailyHours, WeeklyHours })
					break
				}
			}
		}

		this.setState({
			pending: result.Pending,
			dailyNoteDates: result.DailyNoteDates,
			timecard: result.Timecard,
			lockData: result.PayrollStatus,
			showComponentTimecards: !result.Pending && result.Timecard.ComponentTimecards && result.Timecard.ComponentTimecards.length > 1 ?
				this.state.showComponentTimecards :
				false,
			showProductiveNonProductiveTime: !result.Pending ? this.state.showProductiveNonProductiveTime : false,
			loadingTimecards: false,
			priorPeriodTimecards: result.PriorPeriodTimecards,
			allowPriorPeriodModifications: result.Timecard && result.Timecard.AllowModifications,
			suspensePunchData: result.SuspensePunchData,
			jobStatusData: result.JobStatusData,
			commentData: result.CommentData
		})

		AppStateStore.getTextProgressSnackbarContent() !== null &&
			AppStateStore.setTextProgressSnackbarContent(null)
		msg ?
			AppStateStore.setProgressSnackbarContent(msg) :
			AppStateStore.getProgressSnackbarContent() === "loading" &&
			AppStateStore.setProgressSnackbarContent(null)
		result.Pending &&
			AppStateStore.setAlertDialogContent({
				buttonTitle: strings.Close,
				title: strings.Timecard_Change_Already_In_Process,
				content: strings.Cannot_generate_timecard,
				icon: <UserLock width={100} height={80} color={grey400} />,
				handleCloseCallBack: () => this.setState({ pendingReviewed: true })
			})
	}

	loadTimecardsAfterUpdatePunch(msg: string) {
		this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
		this.loadTimecards(msg)
	}

	addPunch(userId: string, punchBundle: IPunchBundle) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
		this.setState({ openAddPunchDialog: false }, () => {
			punchActions.addPunch(userId, punchBundle, !this.state.isPunchIn,
				(msg) => this.loadTimecards(msg),
				false,
				null,
				this.state.allowPriorPeriodModifications
			)
		})
	}

	async addPunchToTimecardDay(timecardDay, user: ITimecardEmployee, timecard, hierarchyItemId, positionId, payClassId, payTypeId, shiftId, breakId, mobileBreakId, jobId, phaseId, equipmentId, isPunchIn, pairedPunchId) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		let defaultPositionId
		if (positionId) {
			const positionExists = await api.getPositions(user.Id, hierarchyItemId, shiftId, jobId, phaseId).then(res =>
				res.data.find(item => item.Id === positionId))

			defaultPositionId = positionExists ? positionId : this.props.user.DefaultPositionId
		} else {
			defaultPositionId = positionId
			const result = await punchHelper.checkRemovedDataForPunch(user.Id, hierarchyItemId, shiftId, jobId, phaseId, positionId, true, this.props.user.DefaultPositionId === positionId)
			if (result !== ECheckResultForRemovedPunchData.Valid) return
		}
		// if (positionExists) {const result = await punchHelper.checkRemovedDataForPunch(user.Id, hierarchyItemId, shiftId, jobId, phaseId, positionId, true, this.props.user.DefaultPositionId === positionId)
		// if (result !== ECheckResultForRemovedPunchData.Valid) return
		for (let iter2 = 0; iter2 < this.state.timecard.MasterTimecard.TimecardWeeks.length; iter2++) {
			for (let iter3 = 0; iter3 < this.state.timecard.MasterTimecard.TimecardWeeks[iter2].Days.length; iter3++) {
				if (
					timecardDay.StartDayTime === this.state.timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3].StartDayTime &&
					timecardDay.EndDayTime === this.state.timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3].EndDayTime
				) {
					this.setState({
						punchTimecardDay: this.state.timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3],
						punchTimecard: this.state.timecard,
						defaultAddPunchHierarchyId: hierarchyItemId,
						defaultAddPunchPositionId: defaultPositionId,
						defaultAddPayClassId: payClassId,
						defaultAddPunchPayTypeId: payTypeId,
						defaultAddJobId: jobId,
						defaultShiftId: shiftId,
						defaultBreakId: breakId,
						defaultMobileBreakId: mobileBreakId,
						defaultAddPhaseId: phaseId,
						defaultEquipmentId: equipmentId,
						isPunchIn,
						pairedPunchId: pairedPunchId,
						openAddPunchDialog: true
					})
					break
				}
			}
		}
	}

	onTimeChange(punchId, dateTime, errorCb: () => void) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
		const punch = {
			DateTime: moment(dateTime).utc().format()
		}
		punchActions.patchPunch(this.props.userId, punchId, punch, false, null, this.state.allowPriorPeriodModifications,
			(msg) => this.loadTimecards(msg),
			errorCb
		)
	}

	onDateChange(newDate) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.setState({
			referenceDate: moment(newDate).format()
		}, () =>
			this.loadTimecards()
		)
	}

	onConfirmDelete(punchId) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		punchActions.deletePunchHandler(
			punchId,
			this.state.timecard.MasterTimecard.FullPunchSets.find(ps => ps.PunchInId === punchId || ps.PunchOutId === punchId),
			this.state.allowPriorPeriodModifications,
			(msg) => {
				this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
				this.loadTimecards(msg)
			}
		)
	}

	approveTimecard(dayOfWeekIndex, punchSetApprovalType) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
		approveActions.handleApproveTimecard([this.state.timecard.Id], this.props.filterByJobId ? this.props.filterByJobId : "", dayOfWeekIndex, punchSetApprovalType, this.loadTimecards)
	}

	unapproveTimecard(dayOfWeekIndex, punchSetApprovalType) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
		approveActions.handleUnapproveTimecard([this.state.timecard.Id], this.props.filterByJobId ? this.props.filterByJobId : "", dayOfWeekIndex, punchSetApprovalType, this.loadTimecards)
	}

	handleApproveStatus(status, dayOfWeekIndex, approvalType = EPunchSetApprovalType.Supervisor) {
		if (this.props.loggedInUserType !== ELoggedInUserType.Employee && !this.props.timecardApprovals) return
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		if (this.props.loggedInUserType !== ELoggedInUserType.Employee && this.state.timecard.ObjectId === AuthenticationStore.getLoggedInUser().Id) {
			AppStateStore.setAlertDialogContent({
				title: strings.CannotApproveTimecardsTitle,
				content: status === "approve" ? strings.Supervisor_cannot_approve_his_own_timecard : strings.Supervisor_cannot_unapprove_his_own_timecard
			})
			return
		}

		if (status === "approve") {
			let hasPunchSets: boolean = false
			let hasExpenses: boolean = false
			if (dayOfWeekIndex === -1) {
				hasPunchSets = this.state.timecard.MasterTimecard.FullPunchSets.length > 0
				hasExpenses = timecardHelper.getTimecardAllExpenses(this.state.timecard.MasterTimecard).length > 0
			}
			else {
				const timecardDay = this.state.timecard.MasterTimecard.TimecardWeeks[0].Days[dayOfWeekIndex]
				hasPunchSets = timecardDay.PunchSets && timecardDay.PunchSets.length > 0 ? true : false
				hasExpenses = ((timecardDay.Expenses || []).length + (timecardDay.TimeExpenses || []).length) > 0
			}

			const allowApprovePunchSet = approvalType === EPunchSetApprovalType.Supervisor ?
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ApproveTimecards) :
				AccountStore.getEmployeeApproveTimecardEnabled()
			const allowApproveExpenses = approvalType === EPunchSetApprovalType.Supervisor ?
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense) :
				AccountStore.getEmployeeApproveTimecardEnabled()

			!hasExpenses && !allowApprovePunchSet ?
				AppStateStore.setProgressSnackbarContent(strings.You_have_not_a_permission_to_approve_punchSet) :
				!hasPunchSets && !allowApproveExpenses ?
					AppStateStore.setProgressSnackbarContent(strings.You_have_not_a_permission_to_approve_expenses) :
					AppStateStore.setConfirmDialogContent({
						title: strings.Approve_Timecard,
						content:
							approvalType === EPunchSetApprovalType.Employee ?
								AccountStore.getCurrentAccountSettings().FeatureSettings.EnableEmpTimecardApproveAttestation && AccountStore.getCurrentAccountSettings().FeatureSettings.EmpTimecardApproveAttestation ?
									AccountStore.getCurrentAccountSettings().FeatureSettings.EmpTimecardApproveAttestation :
									strings.Are_you_sure_you_want_to_approve_the_timecard :
								hasPunchSets && !permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ApproveTimecards) ?
									strings.approve_only_expenses :
									hasExpenses && !permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense) ?
										strings.approve_only_punchset :
										strings.Are_you_sure_you_want_to_approve_the_timecard,
						confirm: () => this.approveTimecard(dayOfWeekIndex, approvalType)
					})
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Unapprove_Timecard,
				content: strings.Are_you_sure_you_want_to_unapprove_timecard,
				confirm: () => this.unapproveTimecard(dayOfWeekIndex, approvalType)
			})
		}
	}

	handleApprovePunchSet(status, punchSet: IPunchSetDocument) {
		if (this.props.loggedInUserType !== ELoggedInUserType.Employee && !this.props.timecardApprovals) return
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		if (this.props.loggedInUserType !== ELoggedInUserType.Employee && this.state.timecard.ObjectId === AuthenticationStore.getLoggedInUser().Id) {
			AppStateStore.setAlertDialogContent({
				title: strings.CannotApproveTimecardsTitle,
				content: status === "approve" ? strings.Supervisor_cannot_approve_his_own_timecard : strings.Supervisor_cannot_unapprove_his_own_timecard
			})
			return
		}

		AppStateStore.setConfirmDialogContent({
			title: status === "approve" ? strings.Approve_PunchSet : strings.Unapprove_PunchSet,
			content: status === "approve" ? strings.Are_you_sure_you_want_to_approve_punchSet : strings.Are_you_sure_you_want_to_unapprove_punchSet,
			confirm: () => {
				this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
				status === "approve" ?
					approveActions.approvePunchSet(punchSet, this.loadTimecards) :
					approveActions.unApprovePunchSet(punchSet, this.loadTimecards)
			}
		})
	}

	openDailyHistoryDrawer(date) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		this.setState({ dailyDrawerDate: date })
	}

	fullTimecardClosed() {
		let closeData = this.state.lockData
		let closed = true

		if (!closeData || closeData.length === 0) {
			return false
		} else {
			closeData.forEach(cd => {
				closed = closed && cd.ClosedData.IsClosed
			})
		}

		return closed
	}

	async handleRecalculate() {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return

		AppStateStore.setProgressSnackbarContent("loading")
		const response = await api.recalculateEmployeeTimecard(this.props.userId, moment(this.state.referenceDate).utc(true).format())
		const res: ITimecardSequenceResult = response.data
		if (res.Result === "recalculated") {
			this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
			this.loadTimecards()
			AppStateStore.setProgressSnackbarContent(strings.successfully_recalculated)
		}
		else if (res.Result === "not allowed to recalc for locked period") {
			AppStateStore.setProgressSnackbarContent(strings.not_allowed_to_recalculate_for_locked_period)
		}
		else {
			AppStateStore.setTimecardSequenceWarningDialogContent({
				warningData: res.WarningData,
				handleRetry: () => this.handleRecalculate()
			})
		}
	}

	handleAcceptSuspensePunches() {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return

		AppStateStore.setProgressSnackbarContent("loading")

		const suspensePunchRecords: IRecord[] = []
		this.state.suspensePunchData && this.state.suspensePunchData.ReviewSuspensePunchData &&
			this.state.suspensePunchData.ReviewSuspensePunchData.map(i =>
				suspensePunchRecords.push({
					UserFirstName: this.props.user.FirstName,
					UserLastName: this.props.user.LastName,
					Punch: {
						Id: i.Id,
						DateTimeLocal: i.DateTimeLocal
					} as IPunchDocument
				} as IRecord)
			)
		this.state.suspensePunchData && this.state.suspensePunchData.ReviewSuspenseUpdateTimeData &&
			this.state.suspensePunchData.ReviewSuspenseUpdateTimeData.map(i =>
				suspensePunchRecords.push({
					UserFirstName: this.props.user.FirstName,
					UserLastName: this.props.user.LastName,
					Punch: {
						Id: i.Id,
						DateTimeLocal: i.DateTimeLocal
					} as IPunchDocument
				} as IRecord)
			)

		api.acceptSuspensePunches(suspensePunchRecords.map(i => i.Punch.Id)).then(res => {
			AppStateStore.setProgressSnackbarContent(null)
			const acceptSuspensePunchResultDialogContent = {
				selectedRecords: suspensePunchRecords,
				acceptResult: res.data
			}
			this.setState({ acceptSuspensePunchResultDialogContent })
		})
	}


	render() {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return null

		const userPunchRuleWeeklyProperties = (this.props.user.PunchRuleProperties || []).filter(item => item.Scope == 1)
		let timecardPunchRuleWeeklyProperties = []
		if (this.state.timecard && this.state.timecard.PunchRuleProperties) {
			timecardPunchRuleWeeklyProperties = this.state.timecard.PunchRuleProperties.filter(item => item.Scope == 1)
		}

		const userPayrollPayGroupData = payGroupAndTypeHelper.getUserPayrollPayGroupDataByReferenceDate(this.props.user, this.state.userEffectiveDates, this.state.referenceDate, true)
		let timecardUI = (
			<div style={{ textAlign: "center" }}>
				<CircularProgress />
			</div>
		)
		if (!this.state.loadingTimecards) {
			if (this.state.pending) {
				timecardUI = (
					<PendingTimecardUI
						pendingReviewed={this.state.pendingReviewed}
						handleGenerateTimecard={async () => {
							this.setState({ pendingReviewed: false })
							await api.generateUserTimecard(this.props.userId)
							this.loadTimecards()
						}}
					/>
				)
			}
			else {
				let masterTimezoneLabel
				const timecard = this.state.timecard

				const suspenseInfoIcon = (
					!this.props.virtualTimecard &&
					<div style={{ width: 30, marginTop: 7 }} key="suspense">
						<TimecardSuspenseInfoIcon
							keyStr={-1}
							dateRange={{ StartDate: this.state.timecard.StartDate, EndDate: this.state.timecard.EndDate }}
							suspensePunchData={this.state.suspensePunchData}
							hideToolTip
							iconSize={24}
							handleOpenVirtualTimecardPopup={() => this.setState({ openVirtualTimecardPopup: true })}
						/>
					</div>
				)
				const supervisorApproveIcon = (
					<ApproveIcon
						key="Supervisor"
						identify="supervisorweekly"
						width={22}
						toolTipPosition="left"
						toolTipArrow="center"
						approvalType={EPunchSetApprovalType.Supervisor}
						punchSets={this.state.timecard.MasterTimecard.FullPunchSets}
						expenses={timecardHelper.getTimecardAllExpenses(this.state.timecard.MasterTimecard)}
					/>
				)
				const supervisorApproveActionIcon = (
					<ApproveIcon
						key="Supervisor"
						identify="supervisorweekly"
						width={22}
						toolTipPosition="left"
						toolTipArrow="center"
						approvalType={EPunchSetApprovalType.Supervisor}
						punchSets={this.state.timecard.MasterTimecard.FullPunchSets}
						expenses={timecardHelper.getTimecardAllExpenses(this.state.timecard.MasterTimecard)}
						handleApproveStatus={status => this.handleApproveStatus(status, -1, EPunchSetApprovalType.Supervisor)}
					/>
				)
				const employeeApproveIcon = (
					<ApproveIcon
						key="Employee"
						identify="employeeweekly"
						width={22}
						toolTipPosition="left"
						toolTipArrow="center"
						approvalType={EPunchSetApprovalType.Employee}
						punchSets={this.state.timecard.MasterTimecard.FullPunchSets}
						expenses={timecardHelper.getTimecardAllExpenses(this.state.timecard.MasterTimecard)}
					/>
				)
				const employeeApproveActionIcon = (
					<ApproveIcon
						key="Employee"
						identify="employeeweekly"
						width={22}
						toolTipPosition="left"
						toolTipArrow="center"
						approvalType={EPunchSetApprovalType.Employee}
						punchSets={this.state.timecard.MasterTimecard.FullPunchSets}
						expenses={timecardHelper.getTimecardAllExpenses(this.state.timecard.MasterTimecard)}
						handleApproveStatus={status => this.handleApproveStatus(status, -1, EPunchSetApprovalType.Employee)}
					/>
				)
				const extSupervisorApproveIcon = (
					AccountStore.getExtSupApproveTimecardEnabled() &&
					<ApproveIcon
						key="ExtSupervisor"
						identify="extsupervisorweekly"
						width={22}
						toolTipPosition="left"
						toolTipArrow="center"
						approvalType={EPunchSetApprovalType.ExtSupervisor}
						punchSets={this.state.timecard.MasterTimecard.FullPunchSets}
						expenses={[]}
					/>
				)

				const timecardWeeklyApprove_SuspenseUI = !this.state.allowPriorPeriodModifications &&
					(
						<div
							key={"1" + timecard.Id}
							style={{
								display: "flex",
								width: "100%",
								justifyContent: "flex-end",
								alignItems: "center",
								borderBottom: "solid 1px rgb(224, 224, 224)",
								paddingTop: 5,
								paddingBottom: 2
							}}
						>
							{this.props.loggedInUserType === ELoggedInUserType.Employee ?
								[
									suspenseInfoIcon,
									AccountStore.getEmployeeApproveTimecardEnabled() &&
									employeeApproveActionIcon,
									supervisorApproveIcon,
									extSupervisorApproveIcon
								] :
								[
									suspenseInfoIcon,
									supervisorApproveActionIcon,
									AccountStore.getEmployeeApproveTimecardEnabled() &&
									employeeApproveIcon,
									extSupervisorApproveIcon
								]
							}
						</div>
					)

				const getPunchRulePropertyInstance = (punchRuleProperty: IRuleProperty): IRuleProperty => {
					let returnVal = null
					if (timecardPunchRuleWeeklyProperties && timecardPunchRuleWeeklyProperties.length > 0) {
						timecardPunchRuleWeeklyProperties.forEach(rule => {
							if (punchRuleProperty.Value === rule.Value) {
								returnVal = rule
							}
						})
					}

					return returnVal
				}

				const getPunchRulePropertyEnabled = (punchRuleProperty: IRuleProperty): boolean => {
					const rule = getPunchRulePropertyInstance(punchRuleProperty)
					if (!rule) {
						return false
					}

					return rule.Enabled
				}

				const getPunchRuleObjectAuditString = (punchRuleProperty: IRuleProperty): string => {
					let returnString = ""

					const ruleInstance = getPunchRulePropertyInstance(punchRuleProperty)
					if (ruleInstance && ruleInstance.ObjectAudit) {
						if (ruleInstance.ObjectAudit.LastModified) {
							returnString = `Last modified ${moment(ruleInstance.ObjectAudit.LastModified).format("h:mma MM/DD/YYYY")} by ${ruleInstance.ObjectAudit.LastModifiedByName}`
						}
					}

					return returnString
				}

				const weeklyPunchRuleProperties = (
					<div style={{ maxWidth: 300, float: "left", margin: 10 }}>
						{userPunchRuleWeeklyProperties &&
							userPunchRuleWeeklyProperties.map((punchRuleProperty: IRuleProperty, index) =>
								<div key={index} title={getPunchRuleObjectAuditString(punchRuleProperty)}>
									<Toggle
										toggled={getPunchRulePropertyEnabled(punchRuleProperty)}
										onToggle={async (e, value) => {
											AppStateStore.setProgressSnackbarContent("loading")
											await api.updatePunchRuleProperty(this.props.user.Id, {
												DisplayName: punchRuleProperty.DisplayName,
												DateTime: timecard.StartDate,
												Value: punchRuleProperty.Value,
												Enabled: value,
												Scope: punchRuleProperty.Scope,
												ObjectAudit: null
											})

											AppStateStore.setProgressSnackbarContent(null)
											this.loadTimecards()
										}}
										labelPosition="right"
										label={punchRuleProperty.DisplayName}
									/>
								</div>
							)}
					</div>
				)

				const timecardToggles = timecard.ComponentTimecards && timecard.ComponentTimecards.length > 0 &&
					(
						<div>
							{userPunchRuleWeeklyProperties && weeklyPunchRuleProperties}
							<div style={{ maxWidth: 300, float: "right", margin: 10 }}>
								<Toggle
									data-intercom-target={`menu-Employees-TimecardDetails-Toggle`}
									toggled={this.state.showTimecardDetails}
									onToggle={() => {
										this.setState({ showTimecardDetails: !this.state.showTimecardDetails }, () => {
											localStorage.setItem("showTimecardDetails", this.state.showTimecardDetails ? "true" : "false")
										})
									}}
									labelPosition="left"
									label={strings.Timecard_Details}
									style={{ maxWidth: 275 }}
								/>
								{timecard.ComponentTimecards && timecard.ComponentTimecards.length > 1 &&
									<Toggle
										data-intercom-target={"menu-Employees-Timecards-Toggle-ShowComponentTimeCards"}
										label={strings.ShowComponentTimecards}
										toggled={this.state.showComponentTimecards}
										onToggle={(e, value) => this.setState({ showComponentTimecards: value, showProductiveNonProductiveTime: value ? false : this.state.showProductiveNonProductiveTime })}
									/>
								}
								<Toggle
									data-intercom-target={"menu-Employees-Timecards-Toggle-ShowProductiveNon-ProductiveTime"}
									label={strings.Show_Productive_Non_Productive_Time}
									toggled={this.state.showProductiveNonProductiveTime}
									onToggle={(e, value) => this.setState({ showProductiveNonProductiveTime: value, showComponentTimecards: value ? false : this.state.showComponentTimecards })}
								/>
							</div>
							<div style={{ clear: "both" }} />
						</div>
					)

				if (timecard.ComponentTimecards && timecard.ComponentTimecards.length > 0) {
					let componentTimecard = timecard.ComponentTimecards[0]
					masterTimezoneLabel = (
						<div>
							<div style={{ float: "right", marginRight: 10 }}>
								<div>
									<i>
										{strings.Hierarchy_Timezone}:&nbsp;
										<HierarchyJobTimezoneStr
											hierarchyId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
											jobId={componentTimecard.JobId}
											utcTime={timecard.StartDateUTC}
										/>
									</i>
								</div>
							</div>
							<div style={{ clear: "both" }} />
						</div>
					)
				}

				const priorPeriodAdjustModifiedTimecardLabel = this.state.allowPriorPeriodModifications && !this.state.timecard.PriorPeriodAdjusted &&
					<b>{`${strings.Modified_Timecard.toUpperCase()} `}</b>

				if (this.state.showComponentTimecards) {
					timecardUI = (
						<div key={"2" + timecard.Id} style={{ borderTop: "solid 1px rgb(224, 224, 224)" }}>
							{timecardWeeklyApprove_SuspenseUI}
							{timecardToggles}
							{priorPeriodAdjustModifiedTimecardLabel}
							{timecard.ComponentTimecards.map((componentTimecard, i) => {
								const account = AccountStore.getCurrentAccount()
								let timecardLabel = account.Name

								if (componentTimecard.HierarchyItem) {
									timecardLabel = componentTimecard.HierarchyItem.Label
								}
								if (componentTimecard.Position) {
									timecardLabel += ": "
								}

								let jobPhaseLabel
								if (componentTimecard.JobId) {
									jobPhaseLabel = ` ${strings.Job}: ${componentTimecard.JobName}`
								}
								if (componentTimecard.JobId && componentTimecard.PhaseId) {
									jobPhaseLabel += ` ${strings.Phase}: ${componentTimecard.PhaseName}`
								}
								return (
									<div
										style={{ borderTop: "solid 1px #efefef", paddingTop: 10 }}
										key={i}
									>
										<b>{timecardLabel}</b>
										{timecardHelper.getTimecardPositionLabel(componentTimecard)}
										{jobPhaseLabel}
										<div style={{ float: "right" }}>
											<i>
												{strings.Hierarchy_Timezone}:&nbsp;
												<HierarchyJobTimezoneStr
													hierarchyId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
													jobId={componentTimecard.JobId}
													utcTime={timecard.StartDateUTC}
												/>
											</i>
										</div>
										{componentTimecard.TimecardWeeks.map((timecardWeek, i) => {
											return (
												<TimecardWeekTable
													dailyNoteDates={this.state.dailyNoteDates}
													timecard={this.state.timecard}
													timecardWeek={timecardWeek}
													lockData={this.state.lockData}
													employee={this.props.user as ITimecardEmployee}
													onAddPunchToTimecardDay={this.addPunchToTimecardDay}
													onTimeChange={this.onTimeChange}
													onConfirmDelete={this.onConfirmDelete}
													readonly={this.props.readonly}
													key={i}
													hierarchyItemId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
													jobId={componentTimecard.JobId}
													phaseId={componentTimecard.PhaseId}
													positionId={componentTimecard.Position ? componentTimecard.Position.Id : null}
													payrollHierarchyId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollHierarchyId : userPayrollPayGroupData.PayrollHierarchyItemId}
													payrollPayGroupId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollPayGroupId : userPayrollPayGroupData.PayrollPayGroupId}
													openDailyHistoryDrawer={this.openDailyHistoryDrawer}
													reloadTimecard={this.loadTimecardsAfterUpdatePunch}
													handleApproveStatus={this.handleApproveStatus}
													loggedInUserType={this.props.loggedInUserType}
													isFullTimecard
													showExpenseRow
													suspensePunchData={this.state.suspensePunchData}
													jobStatusData={this.state.jobStatusData}
													commentData={this.state.commentData}
													virtualTimecard={this.props.virtualTimecard}
													handleOpenVirtualTimecardPopup={() => this.setState({ openVirtualTimecardPopup: true })}
													hideInfoIcon={this.props.hideInfoIcon}
													handleApprovePunchSet={this.handleApprovePunchSet}
													showTimecardDetails={this.state.showTimecardDetails}
													payrollDataForPayGroup={userPayrollPayGroupData}
												/>
											)
										})}
									</div>
								)
							})}
						</div>
					)
				}
				else {
					let timecardLabel = ""
					let positionLabel = ""
					let labelPadding
					//If we only have one component timecard, show the info at the top of it.
					if (timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1) {
						const componentTimecard = timecard.ComponentTimecards[0]
						timecardLabel = AccountStore.getCurrentAccount() ? AccountStore.getCurrentAccount().Name : ""
						labelPadding = <div style={{ marginTop: 20 }} />

						if (componentTimecard.HierarchyItem) {
							timecardLabel = componentTimecard.HierarchyItem.Label
						}

						if (componentTimecard.Position) {
							timecardLabel += ": "
						}
						positionLabel = timecardHelper.getTimecardPositionLabel(componentTimecard)
					}

					let jobPhaseLabel
					if (timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1) {
						if (timecard.ComponentTimecards[0].JobId) {
							jobPhaseLabel = ` ${strings.Job}: ${timecard.ComponentTimecards[0].JobName}`
						}
						if (timecard.ComponentTimecards[0].JobId && timecard.ComponentTimecards[0].PhaseId) {
							jobPhaseLabel += ` ${strings.Phase}: ${timecard.ComponentTimecards[0].PhaseName}`
						}
					}

					timecardUI =
						<div>
							<div style={{ borderTop: "solid 1px rgb(224, 224, 224)" }}>
								{timecardWeeklyApprove_SuspenseUI}
								{labelPadding}
								{priorPeriodAdjustModifiedTimecardLabel}
								<b>{timecardLabel}</b>
								{positionLabel}
								{jobPhaseLabel}
								{timecardToggles}
								{masterTimezoneLabel}
								{this.state.showProductiveNonProductiveTime ?
									(() => {
										const productiveTimecard = timecardHelper.getProductiveTimecard(timecard)
										const nonProductiveTimecard = timecardHelper.getNonProductiveTimecard(timecard)
										return (
											<div>
												<div style={{ borderTop: "solid 1px #efefef", paddingTop: 10 }}>
													<b>{strings.Productive_Time}</b>
													<TimecardWeekTable
														dailyNoteDates={this.state.dailyNoteDates}
														timecard={this.state.timecard}
														timecardWeek={productiveTimecard.TimecardWeeks[0]}
														lockData={this.state.lockData}
														employee={this.props.user as ITimecardEmployee}
														onAddPunchToTimecardDay={this.addPunchToTimecardDay}
														onTimeChange={this.onTimeChange}
														onConfirmDelete={this.onConfirmDelete}
														readonly={this.props.readonly}
														hierarchyItemId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].HierarchyItem ?
																timecard.ComponentTimecards[0].HierarchyItem.Id :
																null :
															timecard.Employee.DefaultPunchHierarchyId
														}
														jobId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].JobId :
															this.props.user.DefaultJobId
														}
														phaseId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].PhaseId :
															this.props.user.DefaultPhaseId
														}
														positionId={
															timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
																timecard.ComponentTimecards[0].Position ?
																	timecard.ComponentTimecards[0].Position.Id :
																	null :
																timecard.Employee.DefaultPositionId
														}
														payrollHierarchyId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollHierarchyId : userPayrollPayGroupData.PayrollHierarchyItemId}
														payrollPayGroupId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollPayGroupId : userPayrollPayGroupData.PayrollPayGroupId}
														openDailyHistoryDrawer={this.openDailyHistoryDrawer}
														reloadTimecard={this.loadTimecardsAfterUpdatePunch}
														handleApproveStatus={this.handleApproveStatus}
														loggedInUserType={this.props.loggedInUserType}
														isFullTimecard
														showExpenseRow
														suspensePunchData={this.state.suspensePunchData}
														jobStatusData={this.state.jobStatusData}
														commentData={this.state.commentData}
														virtualTimecard={this.props.virtualTimecard}
														handleOpenVirtualTimecardPopup={() => this.setState({ openVirtualTimecardPopup: true })}
														hideInfoIcon={this.props.hideInfoIcon}
														handleApprovePunchSet={this.handleApprovePunchSet}
														showTimecardDetails={this.state.showTimecardDetails}
														payrollDataForPayGroup={userPayrollPayGroupData}
													/>
												</div>
												<div style={{ borderTop: "solid 1px #efefef", paddingTop: 10 }}>
													<b>{strings.Non_Productive_Time}</b>
													<TimecardWeekTable
														dailyNoteDates={this.state.dailyNoteDates}
														timecard={this.state.timecard}
														timecardWeek={nonProductiveTimecard.TimecardWeeks[0]}
														lockData={this.state.lockData}
														employee={this.props.user as ITimecardEmployee}
														onAddPunchToTimecardDay={this.addPunchToTimecardDay}
														onTimeChange={this.onTimeChange}
														onConfirmDelete={this.onConfirmDelete}
														readonly={this.props.readonly}
														hierarchyItemId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].HierarchyItem ?
																timecard.ComponentTimecards[0].HierarchyItem.Id :
																null :
															timecard.Employee.DefaultPunchHierarchyId
														}
														jobId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].JobId :
															this.props.user.DefaultJobId
														}
														phaseId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
															timecard.ComponentTimecards[0].PhaseId :
															this.props.user.DefaultPhaseId
														}
														positionId={
															timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
																timecard.ComponentTimecards[0].Position ?
																	timecard.ComponentTimecards[0].Position.Id :
																	null :
																timecard.Employee.DefaultPositionId
														}
														payrollHierarchyId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollHierarchyId : userPayrollPayGroupData.PayrollHierarchyItemId}
														payrollPayGroupId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollPayGroupId : userPayrollPayGroupData.PayrollPayGroupId}
														openDailyHistoryDrawer={this.openDailyHistoryDrawer}
														reloadTimecard={this.loadTimecardsAfterUpdatePunch}
														handleApproveStatus={this.handleApproveStatus}
														loggedInUserType={this.props.loggedInUserType}
														isFullTimecard
														showExpenseRow
														suspensePunchData={this.state.suspensePunchData}
														jobStatusData={this.state.jobStatusData}
														commentData={this.state.commentData}
														virtualTimecard={this.props.virtualTimecard}
														handleOpenVirtualTimecardPopup={() => this.setState({ openVirtualTimecardPopup: true })}
														hideInfoIcon={this.props.hideInfoIcon}
														handleApprovePunchSet={this.handleApprovePunchSet}
														showTimecardDetails={this.state.showTimecardDetails}
														payrollDataForPayGroup={userPayrollPayGroupData}
													/>
												</div>
											</div>
										)
									})() :
									timecard.MasterTimecard.TimecardWeeks.map((timecardWeek, i) =>
										<TimecardWeekTable
											key={i}
											priorPeriodAdjustMode={this.state.allowPriorPeriodModifications}
											dailyNoteDates={this.state.dailyNoteDates}
											timecard={this.state.timecard}
											timecardWeek={timecardWeek}
											lockData={this.state.lockData}
											employee={this.props.user as ITimecardEmployee}
											onAddPunchToTimecardDay={this.addPunchToTimecardDay}
											onTimeChange={this.onTimeChange}
											onConfirmDelete={this.onConfirmDelete}
											readonly={this.props.readonly}
											hierarchyItemId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
												timecard.ComponentTimecards[0].HierarchyItem ?
													timecard.ComponentTimecards[0].HierarchyItem.Id :
													null :
												timecard.Employee.DefaultPunchHierarchyId
											}
											jobId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
												timecard.ComponentTimecards[0].JobId :
												this.props.user.DefaultJobId
											}
											phaseId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
												timecard.ComponentTimecards[0].PhaseId :
												this.props.user.DefaultPhaseId
											}
											positionId={
												timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
													timecard.ComponentTimecards[0].Position ?
														timecard.ComponentTimecards[0].Position.Id :
														null :
													timecard.Employee.DefaultPositionId
											}
											payrollHierarchyId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollHierarchyId : userPayrollPayGroupData.PayrollHierarchyItemId}
											payrollPayGroupId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollPayGroupId : userPayrollPayGroupData.PayrollPayGroupId}
											openDailyHistoryDrawer={this.openDailyHistoryDrawer}
											reloadTimecard={this.loadTimecardsAfterUpdatePunch}
											handleApproveStatus={this.handleApproveStatus}
											loggedInUserType={this.props.loggedInUserType}
											isFullTimecard
											showExpenseRow
											allowPriorPeriodAdjust={AccountStore.getPriorPeriodAdjustmentsEnabled() && this.fullTimecardClosed() && this.state.allowPriorPeriodModifications}
											suspensePunchData={this.state.suspensePunchData}
											jobStatusData={this.state.jobStatusData}
											commentData={this.state.commentData}
											virtualTimecard={this.props.virtualTimecard}
											handleOpenVirtualTimecardPopup={() => this.setState({ openVirtualTimecardPopup: true })}
											hideInfoIcon={this.props.hideInfoIcon}
											handleApprovePunchSet={this.handleApprovePunchSet}
											showTimecardDetails={this.state.showTimecardDetails}
											payrollDataForPayGroup={userPayrollPayGroupData}
										/>
									)}
							</div>
						</div>
				}
			}
		}

		return (
			<div className="detail-tab EmployeeTimecard" style={{ paddingTop: this.props.byPopup ? 20 : 50 }}>
				{this.props.byPopup &&
					<div style={{ width: "100%", fontSize: 24, fontWeight: "bold", textAlign: "center", padding: "5px 0px 10px 20px" }}>
						{this.props.user.ProfileImageS3Url &&
							<div style={{ display: "inline-block", verticalAlign: "middle", marginRight: 20 }}>
								<ImageLoader url={this.props.user.ProfileImageS3Url} fixedHeight={75} avatar={true} />
							</div>
						}
						<div style={{ display: "inline-block" }}>{`${this.props.user.FirstName}  ${this.props.user.LastName}`}</div>
					</div>
				}
				<EmployeeTimecardActionBar
					user={this.props.user}
					priorPeriodAdjustmentsMode={this.state.allowPriorPeriodModifications}
					readonly={this.props.readonly}
					refenenceDate={this.state.referenceDate}
					timecard={this.state.timecard}
					timecardId={this.state.timecard ? this.state.timecard.Id : null}
					showNoteIcon={!this.props.hideInfoIcon && this.state.timecard && this.state.timecard.MasterTimecard.FullPunchSets.length > 0}
					loggedInUserType={this.props.loggedInUserType}
					employeeName={`${this.props.user.FirstName} ${this.props.user.LastName}`}
					lockData={this.state.lockData}
					payrollPayGroupData={userPayrollPayGroupData}
					byPopup={this.props.byPopup}
					handleChangeReferenceDate={referenceDate => {
						AppStateStore.setProgressSnackbarContent("loading")
						userTimecardActions.handleChangeReferenceDate(referenceDate)
						this.setState({ referenceDate, pendingReviewed: false }, () => this.loadTimecards())
					}}
					handleRecalculate={this.handleRecalculate}
					handleOpenPunchDrawer={() => this.setState({ openPunchDrawer: true })}
					reloadTimecard={this.loadTimecards}
				/>
				<div style={{ clear: "both" }} />
				{//Only show toggle if the timecard hasn't been modified before. This toggle enabled modification but once this is on, the use of the toggle is done. It cannot be "undone"
					AccountStore.getPriorPeriodAdjustmentsEnabled() && this.fullTimecardClosed() && !this.state.allowPriorPeriodModifications &&
					permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustments) &&
					<div>
						<div style={{ width: 200, maxWidth: 250, float: "right", margin: 10 }}>
							<Toggle
								data-intercom-target={"menu-Employees-Timecards-Toggle-AllowLockedTimecardEdit"}
								label={strings.Allow_Retro_Modifications}
								toggled={this.state.allowPriorPeriodModifications}
								onToggle={() => userHelper.checkLoggedInUserPermission(this.props.user) &&
									AppStateStore.setConfirmDialogContent({
										content: strings.Are_you_sure_you_want_to_modify_this_timecard,
										confirm: () => {
											AppStateStore.setProgressSnackbarContent("loading")
											api.setTimecardModifications(this.props.userId, this.state.timecard.Id || "", !this.state.allowPriorPeriodModifications, moment(this.state.referenceDate).utc(true).format()).then(() =>
												this.loadTimecards()
											)
										}
									})}
							/>
						</div>
						<div style={{ clear: "both" }} />
					</div>
				}
				{timecardUI}
				{this.state.priorPeriodTimecards && this.state.allowPriorPeriodModifications &&
					<TimecardPriorPeriodAdjustments
						timecardReferenceDate={this.state.referenceDate}
						payrollPayGroupData={userPayrollPayGroupData}
						loggedInUserType={this.props.loggedInUserType}
						priorPeriodTimecards={this.state.priorPeriodTimecards}
						lockData={this.state.lockData}
						userId={this.props.userId}
						reloadTimecards={this.loadTimecardsAfterUpdatePunch}
					/>
				}
				{this.state.openAddPunchDialog &&
					<AddPunchDialog
						date={this.state.punchTimecardDay.LocalStartDayTime}
						user={this.props.user as IUIUser}
						onRequestClose={() => this.setState({ openAddPunchDialog: false })}
						addPunch={this.addPunch}
						hierarchyId={this.state.defaultAddPunchHierarchyId}
						positionId={this.state.defaultAddPunchPositionId}
						payClassId={this.state.defaultAddPayClassId}
						payTypeId={this.state.defaultAddPunchPayTypeId}
						shiftId={this.state.defaultShiftId}
						breakId={this.state.defaultBreakId}
						mobileBreakId={this.state.defaultMobileBreakId}
						jobId={this.state.defaultAddJobId}
						phaseId={this.state.defaultAddPhaseId}
						equipmentId={this.state.defaultEquipmentId}
						isPunchIn={this.state.isPunchIn}
						pairedPunchId={this.state.pairedPunchId}
						payrollHierarchyId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollHierarchyId : userPayrollPayGroupData.PayrollHierarchyItemId}
						payrollPayGroupId={this.state.timecard && this.state.timecard.PayrollPayGroupId ? this.state.timecard.PayrollPayGroupId : userPayrollPayGroupData.PayrollPayGroupId}
						isEmployeePermissionPriority
					/>
				}
				<TimecardDailyDrawer
					byEmployee
					dayNum={this.state.dailyDrawerDate}
					imageS3Url={this.props.user.ProfileImageS3Url}
					timecard={this.state.timecard}
					userId={this.props.userId}
					objectTimecardId={this.state.timecard ? this.state.timecard.Id : null}
					timecardDates={this.state.timecard && { StartDate: this.state.timecard.StartDate, EndDate: this.state.timecard.EndDate }}
					enableBreadcrumb={this.props.user.EnableBreadcrumb}
					closeDailyDrawer={() => this.setState({ dailyDrawerDate: null })}
				/>
				{!this.props.byPopup &&
					<EmployeeTimecardPunchDrawer
						open={this.state.openPunchDrawer}
						referenceDate={this.state.referenceDate}
						user={this.props.user as IUIUser}
						payrollPayGroupData={userPayrollPayGroupData}
						handleClose={() => {
							punchActions.initEditablePunchStore()
							this.setState({ openPunchDrawer: false })
						}}
						handleGenerateTimecard={async actionPunches => {
							AppStateStore.setTextProgressSnackbarContent({
								progressText: strings.Generating_timecard_please_wait
							})
							const res = await api.handleActionPunches(this.props.user.Id, actionPunches)
							const punchActionsResult: IPunchResult[] = res.data
							if (punchActionsResult.length > 0) {
								AppStateStore.setTextProgressSnackbarContent(null)
								this.setState({ punchActionsResult })
							}
							else {
								this.loadTimecards()
							}
						}}
					/>
				}
				{this.state.punchActionsResult.length > 0 &&
					<PunchResultDialog
						results={this.state.punchActionsResult}
						handleClose={() => {
							this.setState({ punchActionsResult: [] })
							this.loadTimecards()
						}}
					/>
				}
				{this.state.openVirtualTimecardPopup &&
					<TimecardPopup
						open
						employeeId={this.props.userId}
						referenceDate={this.state.referenceDate}
						readonly={this.props.readonly}
						virtualTimecard
						handleClose={() => this.setState({ openVirtualTimecardPopup: false }, () =>
							this.loadTimecards()
						)}
						handleRecalcPage={this.props.handleRecalcPage}
					/>
				}
				{this.state.acceptSuspensePunchResultDialogContent &&
					<AcceptSuspensePunchResultDialog
						selectedRecords={this.state.acceptSuspensePunchResultDialogContent.selectedRecords}
						acceptResult={this.state.acceptSuspensePunchResultDialogContent.acceptResult}
						handleClose={() => {
							const notAcceptedPunchAudits = this.state.acceptSuspensePunchResultDialogContent.selectedRecords.map(i => this.state.acceptSuspensePunchResultDialogContent.acceptResult[i.Punch.Id]).filter(i => i !== null)
							this.setState({ acceptSuspensePunchResultDialogContent: null })
							if (this.state.acceptSuspensePunchResultDialogContent.selectedRecords.length !== notAcceptedPunchAudits.length) {
								this.props.byPopup && this.props.handleRecalcPage && this.props.handleRecalcPage()
								this.loadTimecards()
							}
						}}
					/>
				}
			</div>
		)
	}
}